import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { routePaths } from "../../baseLayout/SidebarMenu";

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    // console.info(`[request] [${JSON.stringify(config)}]`);
    return config;
}

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    // console.error(`[request error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
    // console.info(`[response] [${JSON.stringify(response)}]`);
    return response.data;
}

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
    // console.error(`[response error] [${JSON.stringify(error)}]`);
    const publicPaths = [routePaths.PASSWORD_FORGOT, routePaths.PASSWORD_CHANGE, routePaths.NEW_EVENT, routePaths.VERSION_HISTORY, routePaths.ANALYTICS_DASHBOARD];
    let isPublicUrl: boolean = false;
    publicPaths.map((path) => {
        //There are two paths having same value as analytics, one is private and another is public. so we are adding this check.
        if (path === routePaths.ANALYTICS_DASHBOARD && window.location.href.split(path).pop()) {
            isPublicUrl = true;
        } else {
            isPublicUrl = isPublicUrl ?? window.location.href.includes(path)
        }
    })

    const response = error.response;
    if (response?.status === 401 && response?.data.code === 1) { // Unauthorized access. No token provided or token invalid
        localStorage.removeItem("fielddrive-token");
        if (!isPublicUrl) {
            window.location.href = '/login'; // the react admin auth provider will redirect to login page 
        }
    }
    return Promise.reject(error);
}

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
}